import { render } from "./BlogOutsourcingWebDevelopment.vue?vue&type=template&id=3d1c31c6"
import script from "./BlogOutsourcingWebDevelopment.vue?vue&type=script&lang=js"
export * from "./BlogOutsourcingWebDevelopment.vue?vue&type=script&lang=js"

import "./BlogOutsourcingWebDevelopment.vue?vue&type=style&index=0&id=3d1c31c6&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__